import { app } from '../app';

app.factory('UserPhoneNumber', UserPhoneNumber);

/** @ngInject */
function UserPhoneNumber($resource) {
    return $resource('app/rest/phonenumbers/:id', {}, {
        'query' : {
            method : 'GET',
            isArray : true
        },
        'get' : {
            method : 'GET'
        },
        'deletePendingNumber' : {
            url : 'app/rest/phonenumbers/:id?status=PENDING',
            method : 'DELETE'
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/services/user-phone-number.service.js